import { Route } from '@angular/router';

export const settingsRoutes: Route[] = [
  {
    path: 'services',
    loadComponent: () =>
      import('./services/services.component').then((m) => m.ServicesComponent),
  },
  {
    path: 'continents/nuevo',
    loadComponent: () =>
      import('./continents/continents.component').then(
        (m) => m.ContinentsComponent,
      ),
  },
  {
    path: 'continents/:id/edit',
    loadComponent: () =>
      import('./continents/continents.component').then(
        (m) => m.ContinentsComponent,
      ),
  },
  {
    path: 'continents/:id/view',
    loadComponent: () =>
      import('./continents/continents.component').then(
        (m) => m.ContinentsComponent,
      ),
  },
  {
    path: 'continents',
    loadComponent: () =>
      import('./continents/continents.component').then(
        (m) => m.ContinentsComponent,
      ),
  },
  {
    path: 'countries/new',
    loadComponent: () =>
      import('./countries/countries.component').then(
        (m) => m.CountriesComponent,
      ),
  },
  {
    path: 'countries/:id/edit',
    loadComponent: () =>
      import('./countries/countries.component').then(
        (m) => m.CountriesComponent,
      ),
  },
  {
    path: 'countries/:id/view',
    loadComponent: () =>
      import('./countries/countries.component').then(
        (m) => m.CountriesComponent,
      ),
  },
  {
    path: 'countries',
    loadComponent: () =>
      import('./countries/countries.component').then(
        (m) => m.CountriesComponent,
      ),
  },
  {
    path: 'currencies/new',
    loadComponent: () =>
      import('./currencies/currencies.component').then(
        (m) => m.CurrenciesComponent,
      ),
  },
  {
    path: 'currencies/:id/view',
    loadComponent: () =>
      import('./currencies/currencies.component').then(
        (m) => m.CurrenciesComponent,
      ),
  },
  {
    path: 'currencies/:id/edit',
    loadComponent: () =>
      import('./currencies/currencies.component').then(
        (m) => m.CurrenciesComponent,
      ),
  },
  {
    path: 'currencies',
    loadComponent: () =>
      import('./currencies/currencies.component').then(
        (m) => m.CurrenciesComponent,
      ),
  },
  {
    path: 'exchange-rates',
    loadComponent: () =>
      import('./exchange-rates/exchange-rates.component').then(
        (m) => m.ExchangeRatesComponent,
      ),
  },
  {
    path: 'users',
    loadComponent: () =>
      import('./users/users.component').then((m) => m.UsersComponent),
  },
  {
    path: 'preloaded-clients',
    loadComponent: () =>
      import('./preloaded-clients/preloaded-clients.component').then(
        (m) => m.PreloadedClientsComponent,
      ),
  },
  {
    path: 'profiles-permissions',
    loadComponent: () =>
      import('./profiles-permissions/profiles-permissions.component').then(
        (m) => m.ProfilesPermissionsComponent,
      ),
  },
  {
    path: 'generales',
    loadComponent: () =>
      import('./generales/generales.component').then(
        (m) => m.GeneralesComponent,
      ),
  },
  {
    path: 'shipping-method/new',
    loadComponent: () =>
      import('./shipping-method/shipping-method.component').then(
        (m) => m.ShippingMethodComponent,
      ),
  },
  {
    path: 'shipping-method/:id/edit',
    loadComponent: () =>
      import('./shipping-method/shipping-method.component').then(
        (m) => m.ShippingMethodComponent,
      ),
  },
  {
    path: 'shipping-method/:id/view',
    loadComponent: () =>
      import('./shipping-method/shipping-method.component').then(
        (m) => m.ShippingMethodComponent,
      ),
  },
  {
    path: 'shipping-method',
    loadComponent: () =>
      import('./shipping-method/shipping-method.component').then(
        (m) => m.ShippingMethodComponent,
      ),
  },
];
